import(/* webpackMode: "eager" */ "/vercel/path0/dashboard/components/sandpack-styles.tsx")